import React, { useEffect, useState } from "react";
import "./SignUp.css";
import AppLayout from "../../../layout/AppLayout";
import { FaMobileAlt, FaEnvelope } from "react-icons/fa";
import { IoChevronBack } from "react-icons/io5";
import { Button, Form } from "react-bootstrap";
import Email_SignUp from "./Email_SignUp/Email_SignUp";
import Phone_Number_SignUp from "./Phone_Number_SignUp/Phone_Number_SignUp";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Login_Header from "../../Common/Common_Component/Login_Header/Login_Header";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

const SignUp = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("phone");
  const [modalShow, setModalShow] = React.useState(false);
  // Auto close modal and redirect
    useEffect(() => {
      if (modalShow) {
        const timer = setTimeout(() => {
          setModalShow(false);   // Close modal
          navigate("/login");    // Redirect
        }, 3000);
  
        return () => clearTimeout(timer);
      }
    }, [modalShow, navigate]);

  return (
    <>
        <div className="login-page SignUp">
          {/* Header */}
          <Login_Header
            title="Register"
            subTitle="Please Register with your phone number or email"
          />

          {/* Body */}
          <div className="login-body">
            {/* Tabs */}
            <div className="login-tabs">
              <div
                className={`tab ${activeTab === "phone" ? "active" : ""}`}
                onClick={() => setActiveTab("phone")}
              >
                <div>
                  <FaMobileAlt />
                </div>
                Phone Number
              </div>

              <div
                className={`tab ${activeTab === "email" ? "active" : ""}`}
                onClick={() => setActiveTab("email")}
              >
                <div>
                  <FaEnvelope />
                </div>
                Email Sign Up
              </div>
            </div>

            {/* Phone Field */}
            {activeTab === "phone" && <Phone_Number_SignUp />}

            {/* Email Field */}
            {activeTab === "email" && <Email_SignUp />}

            {/* Privacy Agreement */}
            <div className="privacy_check mb-3">
              <Form.Check
                type="checkbox"
                label={
                  <>
                    I have read and agree{" "}
                    <span className="privacy_link">[Privacy Agreement]</span>
                  </>
                }
              />
            </div>

            {/* Buttons */}
            <Button
              className="btn_register_bg mb-3"
              onClick={() => setModalShow(true)}
            >
              Register
            </Button>
            <Button className="btn-register  mb-3">
              {" "}
              <span className="span_text">I have an account </span>
              <span onClick={() => navigate("/login")}>Login</span>
            </Button>
          </div>
        </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg="Register Successfully!"
      />
    </>
  );
};

export default SignUp;
